import SVGContainer from './SVGContainer.container';

export default SVGContainer;
